"use strict";
/**
 * Order Validation
 * Validates order requests before sending to API
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateOrderRequest = validateOrderRequest;
/**
 * Validate order request before sending to the Proxy API
 * @param order - Order request to validate
 * @returns Error message if invalid, null if valid
 */
function validateOrderRequest(order) {
    // 1. Identification & Traceability
    if (!order.ticker) {
        return "Market Ticker is required";
    }
    if (!order.client_id) {
        return "Client ID is required for idempotency";
    }
    // 2. Logic & Side
    if (!order.target_side || !["yes", "no"].includes(order.target_side)) {
        return "Target side must be 'yes' or 'no'";
    }
    // 3. Monetary Constraints
    if (order.dollar_amount < 0) {
        return "Dollar amount must be greater or equal to $0.00";
    }
    // 4. Slippage & Thresholds
    if (order.max_slippage_pts < 0 || order.max_slippage_pts > 100) {
        return "Slippage must be between 0 and 100 points";
    }
    // 5. Orderbook Integrity Checks
    // Validates that we aren't sending empty/placeholder strings if the UI failed to load data
    const priceFields = [
        "yes_bid",
        "yes_ask",
        "no_bid",
        "no_ask",
    ];
    for (const field of priceFields) {
        const value = order[field];
        if (!value || value === "0.0000" || value === "-") {
            return `Valid market data (${field}) is required to execute trade`;
        }
    }
    // 6. Share Constraints
    if (order.min_shares < 0) {
        return "Minimum shares cannot be negative";
    }
    return null;
}
